var map = {
	"./bigpack-badge.svg": "63da",
	"./bigpackfast-badge.svg": "ffb0",
	"./bosspack-badge.svg": "e298",
	"./interpack-badge.svg": "495a",
	"./interpackmaxi-badge.svg": "c947",
	"./jagopack-badge.svg": "4e3a",
	"./jumbopack-badge.svg": "e07fd",
	"./jumbopackh2h-badge.svg": "b14f",
	"./minipack-badge.svg": "cedc",
	"./onepack-badge.svg": "f8b2",
	"./otopack150-badge.svg": "1553",
	"./otopack250-badge.svg": "43c1",
	"./regpack-badge.svg": "7acd",
	"./sameday-badge.svg": "2080",
	"./vippack-badge.svg": "9d64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57a0";